module.exports = __webpack_public_path__ + "img/4738501.svg";